xplenty.directive('ngWidth', function () {
  return function (scope, element, attrs) {
    scope.$watch(attrs.ngWidth, function (value) {
      element.attr('width', value);
    });
  };
});

xplenty.directive('ngHeight', function () {
  return function (scope, element, attrs) {
    scope.$watch(attrs.ngHeight, function (value) {
      element.attr('height', value);
    });
  };
});
